// Plain JSON backup of the goal and the log. The history lives in one browser,
// and someone keeping a run of months should not lose it to a cleared cache.
export const downloadBackup = (goal, log) => {
  const payload = { app: 'quran-reader', exportedAt: new Date().toISOString(), goal, log };
  const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `quran-reader-backup-${new Date().toISOString().slice(0, 10)}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
